export default __webpack_public_path__ + "static/media/3.71c04317.png";